export default "__VITE_ASSET__Cvqwy_03__"